module.exports = __webpack_public_path__ + "img/car_22.245af81d.jpg";